import { useEffect, useState } from "react";
import { useDebounce } from "./useDebounce";
import apiFetch from "../../api/apiFetch";

const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

export function useEmailCheck(email: string) {
  const [emailExists, setEmailExists] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);

  const debouncedEmail = useDebounce(normalizeEmail(email), 500);

  useEffect(() => {
    if (!debouncedEmail || !/\S+@\S+\.\S+/.test(debouncedEmail)) {
      setEmailExists(false);
      setCheckingEmail(false);
      return;
    }

    let cancelled = false;

    const checkEmail = async () => {
      try {
        setCheckingEmail(true);

        const res = await apiFetch("/auth/check-email", {
          method: "POST",
          auth: false,
          body: JSON.stringify({ email: debouncedEmail }),
        });

        if (!cancelled) {
          setEmailExists(Boolean(res.exists));
        }
      } catch {
        if (!cancelled) {
          setEmailExists(false);
        }
      } finally {
        if (!cancelled) {
          setCheckingEmail(false);
        }
      }
    };

    checkEmail();

    return () => {
      cancelled = true;
    };
  }, [debouncedEmail]);

  return {
    emailExists,
    checkingEmail,
  };
}
